import React, { useEffect } from 'react';
import { useRegisterComponent } from '../../../../orchestrator';
import { useWelcomePageContext } from '../../contexts';
import MarketingConsent from '../../../../../components/MarketingConsentCheckbox';
import { RootState, useAppDispatch, useAppSelector } from '../../../../../stores/redux.store';
import { fetchConsentConfig } from '../../../../../actions/marketing-consent-actions';

const marketingConsentSelector = (state: RootState) => state.marketingConsent.config;
const welcomeEmailSelector = (state: RootState) => state.welcome.email;

export const WelcomeMarketingConsent = () => {
  useRegisterComponent(WelcomeMarketingConsent.name);

  const dispatch = useAppDispatch();

  const { setMarketingConsent } = useWelcomePageContext();
  const marketingConsentConfig = useAppSelector(marketingConsentSelector);
  const email = useAppSelector(welcomeEmailSelector);

  useEffect(() => {
    if (email !== '') {
      dispatch(fetchConsentConfig(email));
    }
  }, [dispatch, email]);

  return <MarketingConsent config={marketingConsentConfig} onConsentChange={setMarketingConsent} />;
};
